import PendingDeductionBulkUpload from "../../../views/PendingDeductionBulkUpload.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const PendingDeductionBulkUploadRoutes = [
  {
    menuName: MenuNames.PENDING_DEDUCTION,
    path: "/pending-deduction-bulk-upload",
    component: PendingDeductionBulkUpload,
    exact: true,
  },
];

export default PendingDeductionBulkUploadRoutes;
